import { Flex } from 'foundations-components/components/Flex';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { UsageScreenProvider } from 'marketplace-ui-tracking';
import { Subscreens } from '../../constants/usage';
import { useGates } from '../../hooks/useGates';
import { SortDropdown } from '../../search-results/components/SortDropdown';
import { useFilterConfig } from '../hooks/useFilterConfig';
import { FilterPanelButton } from './FilterPanelButton';
import { SelectFilter } from './reusableFilters/SelectFilter';
import { PortalInstallableFilter } from './singleUseFilters/PortalInstallableFilter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function StorefrontFilterBar({
  filterPanelOpen,
  onFilterPanelOpen
}) {
  const {
    PROFILE_CATALOG_SERVICES,
    PROFILE_INDUSTRIES
  } = useFilterConfig();
  const {
    workflowTemplatesPhase2
  } = useGates();
  return /*#__PURE__*/_jsx(UsageScreenProvider, {
    subscreen: Subscreens.FILTER_BAR,
    children: /*#__PURE__*/_jsxs(CardWrapper, {
      "data-test-id": "storefront-filter-bar",
      paddingInline: "600",
      paddingBlock: "400",
      display: "flex",
      flexDirection: "row",
      alignItems: "start",
      marginBlockEnd: "0",
      gap: "400",
      children: [/*#__PURE__*/_jsxs(Flex, {
        flexWrap: "wrap",
        columnGap: "800",
        flexGrow: 1,
        children: [!workflowTemplatesPhase2 && /*#__PURE__*/_jsx(PortalInstallableFilter, {}), /*#__PURE__*/_jsx(SelectFilter, {
          filter: PROFILE_CATALOG_SERVICES,
          menuWidth: 350,
          showLabel: false
        }), /*#__PURE__*/_jsx(SelectFilter, {
          filter: PROFILE_INDUSTRIES,
          menuWidth: 300,
          showLabel: false
        }), /*#__PURE__*/_jsx(SortDropdown, {})]
      }), !filterPanelOpen && /*#__PURE__*/_jsx(FilterPanelButton, {
        onFilterPanelOpen: onFilterPanelOpen
      })]
    })
  });
}